import axios from "axios"

export const rootUrl = axios.create ({baseURL:"https://erp.apitco.org:8089",})
//export const rootUrl = axios.create ({baseURL:"http://192.168.1.8:8089",})

export const APP_BASE_URL = "https://ts.apitco.org";